<template>
  <b-nav-item-dropdown id="locale-dropdown" right v-if="locales">
    <template v-slot:text>
      <img
        src="@/assets/language-icon.svg"
        alt="languages"
        width="25"
        height="25"
        style="margin-top: -6px"
        v-b-tooltip.hover= "$t('header.language')"
      />
    </template>
    <b-dropdown-item disabled>
      {{ $t("header.language") }}
      <span class="capitalize">{{ currentLocale.caption }}</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      v-for="lang in otherLocales"
      v-bind:key="lang.code"
      @click.prevent="changeLocale(lang.code)"
      ><span class="capitalize">{{ lang.caption }}</span></b-dropdown-item
    >
  </b-nav-item-dropdown>
</template>
<script>
//---- 3rd-parties --------
import { loadLanguageAsync } from "@/app/services/i18n.service.js"
import { mapGetters } from "vuex";

export default {
  watch: {
    async currentLocale(newLocale) {
      if (newLocale && newLocale.code)
       await loadLanguageAsync(newLocale.code)
    }
  },
  methods: {
    async changeLocale(code) {
      if (!await this.checkForUnsavedAuthoringModifications(true))
        return;
      await this.$store.dispatch("header/changeLocale", code)
      this.$router.go() // forces a page refresh
    }
  },
  computed: {
    ...mapGetters({
      locales: "header/locales",
      curLocale: "header/currentLocale",
    }),
    currentLocale() {
      return this.curLocale || {caption: "", code: ""}
    },
    otherLocales() {
      return this.locales.filter(item => item.code !== this.currentLocale.code);
    }
  }
};
</script>
<style scoped>
.capitalize {
  text-transform: capitalize;
}
.nav-item {
  width: 48px !important;
}
</style>